import clsx from 'clsx'
import dayjs from 'dayjs';
import hazardIcon from '../../../assets/icons/popup-hazard.svg'

const AlertsPopup = ({ alertsData = {} }) => {    
    const formatDate = (date: string) => {
        const formatted = dayjs(date).format('MMM D - h:mm A')
        return formatted
    }        
    let sensor = alertsData?.properties?.sensor
    let activeAlerts =  alertsData?.properties?.alerts || []
    return (
        <div className="flex flex-col gap-2 h-full justify-center w-auto">
            <div className='flex justify-between'> 
                <div className='flex gap-2 items-center'>
                    <div className="header">
                        Alerts Data
                    </div>
                    <div className="font-semibold  border shadow-sm p-1 rounded-full bg-[#F1F5F9]">
                        {sensor}
                    </div>
                </div>
            </div>
            <div className="subHeader w-full h-5 flex gap-2 items-center">
                Active Alerts
            </div>
            <hr/>
            <div className='grid grid-cols-2 gap-2'>
                {
                    activeAlerts.map((item, index) => (
                    <>
                        <div className={clsx('datafields flex gap-2 justify-left items-center bg-[#FF5F15]/20 animate-pulse-border')}>
                            <div className="w-8 h-8 flex">
                                <img src={hazardIcon} alt="Icon" />
                            </div>
                            <div className='flex flex-col'>
                                <div className='subHeader'>{item.hazardType.split("_")[1]}</div>
                                <div className='labelStyling'>{`${formatDate(item.expires)}`}</div>
                                <div className='valueStyling'> {Math.round(item.mag)} {item.thresholdUnits} </div>
                            </div>
                        </div>
                    </>
                    ))
                }
            </div>
        </div>
    )
}

export default AlertsPopup
